<template>
  <div class="withdraw">
    <div class="has-money" v-if="hasMoney">
      <div class="money-wrapper">
        <div class="icon">￥</div>
        <div class="money">{{ info.amount }}</div>
      </div>
      <div class="tips">我的奖励金</div>
      <div class="wechat">
        <div class="wechat-title">手机号:</div>
        <div class="wechat-mobile">{{ info.mobile }}</div>
      </div>
      <div class="contact-title">请微信联系老师进行提现</div>
      <div class="qr">
        <img :src="info.wechatImageUrl" class="qr-code" />
      </div>
      <div class="qr-tips">辅导老师微信二维码</div>
      <div class="withdraw-tips">最低提取⾦金额需满100元。</div>
    </div>
    <div class="no-money" v-else>
      <div class="no-money-icon"></div>
      <div class="no-money-tips">暂⽆邀请奖励</div>
      <div class="no-money-btn" @click="shareClick">⽴即邀请得现⾦</div>
    </div>
    <div class="loading" v-show="!isDone">
      <van-loading type="spinner" color="#1989fa" />
    </div>
  </div>
</template>

<script>
import { Toast, Loading } from "vant"
import { withdrawal } from '../../request/api/recommend'
export default {
  components: {
    [Toast.name]: Toast,
    [Loading.name]: Loading
  },
  data () {
    return {
      openid: '',
      info: {},
      hasMoney: false,
      isDone: false
    }
  },
  created () {
    this.openid = this.$route.query.openid || 'oKxpc6VuNHThOH49GCD08Vu2k_9Q'
    this._withdrawal()
  },
  methods: {
    async _withdrawal () {
      const { code, data, msg } = await withdrawal({
        openid: this.openid
      })
      if (code === 0) {
        if (data.amount > 0) {
          this.hasMoney = true
        }
        this.info = data
      } else {
        Toast.fail({
          type: "fail",
          message: msg,
          duration: 1000
        })
      }
      this.isDone = true
    },
    shareClick () {
      this.$router.push({
        name: "share",
        query: {
          distributorId: this.$route.query.distributorId,
          distributorType: 2
        }
      })
    },
  }
}
</script>

<style lang='less' scoped>
.withdraw {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 120px;
  .has-money {
    display: flex;
    flex-direction: column;
    align-items: center;
    .money-wrapper {
      display: flex;
      .icon {
        margin-top: 5px;
        font-size: 32px;
        font-family: SFProDisplay-Regular, SFProDisplay;
        font-weight: 400;
        color: #ff5330;
        line-height: 38px;
      }
      .money {
        margin-left: 4px;
        font-size: 56px;
        font-family: SFProDisplay-Medium, SFProDisplay;
        font-weight: 500;
        color: #ff5330;
        line-height: 67px;
      }
    }
    .tips {
      margin-top: 10px;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
    .wechat {
      display: flex;
      margin-top: 24px;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 37px;
    }
    .contact-title {
      margin-top: 100px;
      font-size: 30px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #222222;
      line-height: 40px;
    }
    .qr {
      width: 282px;
      height: 282px;
      margin-top: 16px;
      .qr-code {
        display: block;
        width: 282px;
        height: 282px;
      }
    }
    .qr-tips {
      margin-top: 10px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 40px;
    }
    .withdraw-tips {
      display: flex;
      justify-content: center;
      position: absolute;
      left: 0;
      bottom: 120px;
      width: 100%;
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #666666;
    }
  }
  .no-money {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 250px;
    .no-money-icon {
      width: 262px;
      height: 200px;
      background: url("./no.png") no-repeat;
      background-size: cover;
    }
    .no-money-tips {
      margin-top: 32px;
      font-size: 34px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #222222;
      line-height: 48px;
    }
    .no-money-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 626px;
      height: 90px;
      margin-top: 120px;
      background: #0293de;
      border-radius: 45px;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }
  }
  .loading {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>